import {Show} from 'platform/foundation';

import {useSelector} from 'react-redux';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {suffixTestId, TestIdProps} from 'shared/web';

import {selectVideoWalkthrough} from '../../../store/carAudit/selectors';
import {useConditionContext} from '../hooks/useConditionContext';
import {AuditCategoryUniqueKey} from '../types/AuditCategoryUniqueKey';
import {AuditParamType} from '../types/AuditParamType';
import {findByParamType} from '../utils/findByParamType';
import {findCategoryByUniqueKey} from '../utils/findCategoryByUniqueKey';
import {PhotoDocumentationCard} from './PhotoDocumentationCard';

export function VideoWalkthrough(props: TestIdProps) {
  const videoWalkthrough = useSelector(selectVideoWalkthrough);
  const {isCreateVehicle} = useConditionContext();

  if (!videoWalkthrough) {
    return null;
  }

  const videos = findCategoryByUniqueKey(videoWalkthrough, AuditCategoryUniqueKey.VIDEOS);
  const videosParam = findByParamType(
    videos?.paramDefinitions?.relatedActions,
    AuditParamType.VIDEO
  );

  return (
    <Show when={isNotNilOrEmpty(videosParam) && isNotNilOrEmpty(videos) && !isCreateVehicle}>
      {/*
        AuditVideos component is not ready to be used in VehicleCreateForm (isCreateVehicle)

        To use it while vehicle is being created, instead of calling onVideoProcessed
        call pushConditionAsset from VehicleCreate context and implement assigning the video
        to the audit in VehicleCreateForm's saveConditionData (there the videos are taken
        from the context by getConditionAssets)
       */}
      <PhotoDocumentationCard
        categoryId={videos?.id!} // eslint-disable-line typescript/no-non-null-asserted-optional-chain -- Muted pre-existing violation
        paramDefinition={videosParam!}
        label={videosParam?.label}
        multiple
        isVideo
        data-testid={suffixTestId('videosDocumentationCard', props)}
      />
    </Show>
  );
}
